import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { t } = useTranslation();
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? match[1] : null;
      const path = location.pathname === "/" ? "/account" : location.pathname;
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        navigate(path, { replace: true, state: { user: data } });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#144733]" data-testid="auth-callback-loading">
      <div className="text-white heading-upper tracking-widest text-sm animate-pulse">{t("Signing you in…")}</div>
    </div>
  );
}
